import { reducer as adminReducer } from './admin.slice';

export default adminReducer;
